import { Soglia, Soglie } from "./soglie";

export class Offerte {
    public Id_Offerta: number;
    public Id_Foritore: number;
    public Id_comodity: number;
    public TipoContratto: number; // 1 residenziale - 2 business
    public NomeOfferta: string;
    public DescrizioneNomeOfferta: string;
    public PromozioneOfferta: string;
    public Sezioni: Array<SezioneOfferta>;
    public PrezzoEle: number;
    public PrezzoGas: number;
    public Flg_Indicizzato: boolean;
    public LinkFoto: string;
    public LinkFotoLarge: string;
    public LinkFotoMid: string;
    public LinkFotoSm: string;
    public LinkFotoCarousel: string
    public DescrizioneCarousel: string;
    public TitoloPlus: string;
    public Plus: Array<string>;

    public schedaconfrontabilitaele: SchedaConfrontabilitaEle;
    public schedaconfrontabilitagas:SchedaConfrontabilitaGas;

    public lstModalitaPagamento: Array<string>;

    public scontoRid:number;

    public TipoSoglieEle:Array<Soglia>;

    public ImportoAnnuoLordo: number;
    public ImportoAnnuoNetto: number;
    public ImportoMensileLordo: number;
    public ImportoMensileNetto: number;
    public iscopertura: string;

}

export  class SezioneOfferta {

    public NomeSezione: string;
    public DescrizioneSezione: string;
    public lstPunti: Array<string>;
}

export class SchedaConfrontabilitaEle{
 public tabellaConfrontabilita :Array<DettaglioSchedaConfrontabilitaEle>;
}

export class DettaglioSchedaConfrontabilitaEle
{
    public consumoannuo:number;
    public tipoprofilo:number;
    public Residente: number;
    public potenza:number;
    public importo:number;
}

export class SchedaConfrontabilitaGas{
    public tabellaConfrontabilita :Array<DettaglioSchedaConfrontabilitaGas>;
   }

   export class DettaglioSchedaConfrontabilitaGas
   {
       public consumoannuo:number;
       public zona:number;
       public importo:number;
   }



// WEBPACK FOOTER //
// ./src/app/model/offerte.ts